(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adaptis-cars-showcase"] && !Shopify.designMode) return;
  try {
    

/* Initialize native scroll carousel */
function initCarsShowcase(root) {
  if (!root) return;

  const scroller = root.querySelector(".carousel");
  const prev = root.querySelector(".carousel-prev");
  const next = root.querySelector(".carousel-next");
  const filterButtons = root.querySelectorAll(".filter-button");

  if (!scroller || !prev || !next) return;

  // Filter functionality
  function handleFilter(filterValue) {
    const slides = root.querySelectorAll(".carousel-slide");
    
    slides.forEach(slide => {
      const brand = slide.getAttribute("data-car-brand") || "";
      const normalizedBrand = brand.toLowerCase();
      const normalizedFilter = filterValue.toLowerCase();
      
      if (normalizedFilter === "all" || normalizedBrand === normalizedFilter || normalizedBrand.includes(normalizedFilter)) {
        slide.classList.remove("filtered-out");
        slide.style.display = "";
      } else {
        slide.classList.add("filtered-out");
        slide.style.display = "none";
      }
    });

    // Update active filter button
    filterButtons.forEach(btn => {
      if (btn.getAttribute("data-filter") === filterValue) {
        btn.classList.add("filter-button--active");
      } else {
        btn.classList.remove("filter-button--active");
      }
    });

    // Reset scroll position
    scroller.scrollTo({ left: 0, behavior: 'smooth' });
    
    // Update button states after filter
    setTimeout(updateButtons, 100);
  }

  // Attach filter button handlers
  filterButtons.forEach(button => {
    button.addEventListener("click", () => {
      const filterValue = button.getAttribute("data-filter");
      handleFilter(filterValue);
    });
  });

  // Calculate step based on first card width + gap
  function getScrollStep() {
    const firstSlide = scroller.querySelector(".carousel-slide");
    if (!firstSlide) return 200;
    
    const slideWidth = firstSlide.offsetWidth;
    const gap = 16; // spaceBetween
    return slideWidth + gap;
  }

  // Update button disabled states
  function updateButtons() {
    const scrollLeft = scroller.scrollLeft;
    const scrollWidth = scroller.scrollWidth;
    const clientWidth = scroller.clientWidth;
    
    // Debug: log scroll dimensions
    console.log('ScrollLeft:', scrollLeft, 'ScrollWidth:', scrollWidth, 'ClientWidth:', clientWidth, 'MaxScroll:', scrollWidth - clientWidth);
    
    prev.disabled = scrollLeft <= 0;
    next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
    
    if (prev.disabled) {
      prev.classList.add("is-disabled");
    } else {
      prev.classList.remove("is-disabled");
    }
    
    if (next.disabled) {
      next.classList.add("is-disabled");
    } else {
      next.classList.remove("is-disabled");
    }
  }

  // Scroll handlers
  prev.onclick = () => {
    const step = getScrollStep();
    scroller.scrollBy({ left: -step, behavior: 'smooth' });
  };

  next.onclick = () => {
    const step = getScrollStep();
    scroller.scrollBy({ left: step, behavior: 'smooth' });
  };

  // Update buttons on scroll
  scroller.addEventListener('scroll', updateButtons);
  
  // Initial button state
  requestAnimationFrame(() => {
    updateButtons();
  });

  // Update on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateButtons, 100);
  });
}

/* Init on load */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-cars-showcase]")
    .forEach(initCarsShowcase);
});

/* Shopify editor support */
document.addEventListener("shopify:section:load", (e) => {
  const section = e.target.querySelector("[data-cars-showcase]");
  if (section) initCarsShowcase(section);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    

/* Initialize native scroll carousel */
function initFeatureCarousel(root) {
  if (!root) return;

  const scroller = root.querySelector(".carousel");
    const prev = root.querySelector(".carousel-prev");
    const next = root.querySelector(".carousel-next");

  if (!scroller || !prev || !next) return;

  // Calculate step based on first card width + gap
  function getScrollStep() {
    const firstSlide = scroller.querySelector(".carousel-slide");
    if (!firstSlide) return 300;
    
    const slideWidth = firstSlide.offsetWidth;
    const gap = 16; // spaceBetween
    return slideWidth + gap;
  }

  // Update button disabled states
  function updateButtons() {
    const scrollLeft = scroller.scrollLeft;
    const scrollWidth = scroller.scrollWidth;
    const clientWidth = scroller.clientWidth;
    
    prev.disabled = scrollLeft <= 0;
    next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
    
    if (prev.disabled) {
      prev.classList.add("is-disabled");
    } else {
      prev.classList.remove("is-disabled");
    }
    
    if (next.disabled) {
      next.classList.add("is-disabled");
    } else {
      next.classList.remove("is-disabled");
    }
  }

  // Scroll handlers
  prev.onclick = () => {
    const step = getScrollStep();
    scroller.scrollBy({ left: -step, behavior: 'smooth' });
  };

  next.onclick = () => {
    const step = getScrollStep();
    scroller.scrollBy({ left: step, behavior: 'smooth' });
  };

  // Update buttons on scroll
  scroller.addEventListener('scroll', updateButtons);
  
  // Initial button state
  requestAnimationFrame(() => {
    updateButtons();
  });

  // Update on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateButtons, 100);
  });
}

/* Init on load */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-feature-carousel]")
    .forEach(initFeatureCarousel);
});

/* Shopify editor support */
document.addEventListener("shopify:section:load", (e) => {
  const section = e.target.querySelector("[data-feature-carousel]");
  if (section) initFeatureCarousel(section);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  const scrollToHashCard = () => {
    const url = new URL(window.location.href);

    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }
  };

  const initAdaptisSort = () => {
    const pageUrl = new URL(window.location.href);
    const sortFromUrl = pageUrl.searchParams.get('sort_by');

    document.querySelectorAll('[data-sort-dropdown]').forEach((dropdown) => {
      const nativeSelect = dropdown.querySelector('.adaptis-sort__native');
      const trigger = dropdown.querySelector('[data-sort-trigger]');
      const valueEl = dropdown.querySelector('[data-sort-value]');
      const menu = dropdown.querySelector('[data-sort-menu]');
      const options = dropdown.querySelectorAll('[data-sort-option]');
      const sectionRoot = dropdown.closest('.adaptis-collection-section');
      const productsWrap = sectionRoot ? sectionRoot.querySelector('.adaptis-collection-layout__products') : null;

      if (!nativeSelect || !trigger || !valueEl || !menu || !options.length) return;

      if (sortFromUrl) {
        const hasOption = Array.from(nativeSelect.options).some((option) => option.value === sortFromUrl);
        if (hasOption) nativeSelect.value = sortFromUrl;
      }

      const syncLabel = () => {
        const selected = nativeSelect.options[nativeSelect.selectedIndex];
        valueEl.textContent = selected ? selected.textContent.trim() : '';

        options.forEach((btn) => {
          btn.setAttribute(
            'aria-selected',
            btn.dataset.value === nativeSelect.value ? 'true' : 'false'
          );
        });
      };

      const close = () => {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');

        if (productsWrap) {
          productsWrap.classList.remove('is-sort-open');
        }
      };

      const open = () => {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.focus();

        if (productsWrap) {
          productsWrap.classList.add('is-sort-open');
        }
      };

      const handleSelect = (e, btn) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        nativeSelect.value = btn.dataset.value;
        syncLabel();
        close();

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', nativeSelect.value);
        nextUrl.searchParams.delete('page');

        window.location.assign(nextUrl.toString());
      };

      syncLabel();

      trigger.addEventListener(
        'pointerdown',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          dropdown.classList.contains('is-open') ? close() : open();
        },
        true
      );

      trigger.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        },
        true
      );

      options.forEach((btn) => {
        btn.addEventListener(
          'pointerdown',
          (e) => handleSelect(e, btn),
          true
        );

        btn.addEventListener(
          'click',
          (e) => handleSelect(e, btn),
          true
        );
      });

      document.addEventListener('pointerdown', (e) => {
        if (!dropdown.contains(e.target)) close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    });
  };

  const initAdaptisAtc = () => {
    if (window._adaptisAtcInit) return;
    window._adaptisAtcInit = true;

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-adaptis-atc-form]');
      if (!form) return;

      e.preventDefault();

      const btn = form.querySelector('[data-adaptis-atc-button]');
      if (!btn) return;

      const defaultText = btn.dataset.textDefault || '+ До кошика';
      const loadingText = btn.dataset.textLoading || 'Додаємо...';
      const addedText = btn.dataset.textAdded || 'Додано в кошик';
      const errorText = 'Помилка';

      btn.textContent = loadingText;
      btn.disabled = true;

      try {
        const variantId = form.querySelector('[name="id"]')?.value;
        const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantity
          })
        });

        const data = await res.json();

        if (!res.ok) {
          console.error('Adaptis ATC error:', data);
          btn.textContent = errorText;

          setTimeout(() => {
            btn.textContent = defaultText;
            btn.disabled = false;
          }, 2000);

          return;
        }

        btn.textContent = addedText;

        await new Promise((resolve) => setTimeout(resolve, 300));

        const cartRes = await fetch(`/cart.js?t=${Date.now()}`, {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });

        const cart = await cartRes.json();

        document
          .querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"]')
          .forEach((el) => {
            el.textContent = cart.item_count;
          });

        const cartBubble = document.querySelector('.cart-bubble');
        if (cartBubble) {
          cartBubble.removeAttribute('hidden');
          cartBubble.classList.remove('visually-hidden');
          cartBubble.style.display = '';
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { cart }
          })
        );

        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart }
          })
        );

        const cartToggle =
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[aria-controls*="cart" i]') ||
          document.querySelector('[aria-haspopup="dialog"][data-cart]') ||
          document.querySelector('[aria-haspopup="dialog"][aria-controls*="cart" i]');

        if (cartToggle) {
          cartToggle.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            })
          );
        }

        setTimeout(() => {
          btn.textContent = defaultText;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('Adaptis ATC request failed:', err);

        btn.textContent = errorText;

        setTimeout(() => {
          btn.textContent = defaultText;
          btn.disabled = false;
        }, 2000);
      }
    });
  };

  const initAdaptisMobileFiltersButton = () => {
    document.querySelectorAll('[data-mobile-filters-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const realToggle =
          document.querySelector('.adaptis-collection-layout__filters .facets-toggle button') ||
          document.querySelector('.adaptis-collection-layout__filters .facets-toggle') ||
          document.querySelector('[aria-controls="filters-drawer"]');

        if (realToggle) {
          realToggle.click();
        }
      });
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      scrollToHashCard();
      initAdaptisSort();
      initAdaptisAtc();
      initAdaptisMobileFiltersButton();
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const scrollToHashCard = () => {
    const url = new URL(window.location.href);

    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }
  };

  const initAdaptisSort = () => {
    const pageUrl = new URL(window.location.href);
    const sortFromUrl = pageUrl.searchParams.get('sort_by');

    document.querySelectorAll('[data-sort-dropdown]').forEach((dropdown) => {
      /* 25.09.2026: після перемальовування секції (фільтри) скрипт підключаємо
         заново, але лише до нових елементів. */
      if (dropdown.dataset.sortBound) return;
      dropdown.dataset.sortBound = '1';
      const nativeSelect = dropdown.querySelector('.adaptis-sort__native');
      const trigger = dropdown.querySelector('[data-sort-trigger]');
      const valueEl = dropdown.querySelector('[data-sort-value]');
      const menu = dropdown.querySelector('[data-sort-menu]');
      const options = dropdown.querySelectorAll('[data-sort-option]');
      if (!nativeSelect || !trigger || !valueEl || !menu || !options.length) return;

      if (sortFromUrl) {
        const hasOption = Array.from(nativeSelect.options).some(
          (option) => option.value === sortFromUrl
        );

        if (hasOption) {
          nativeSelect.value = sortFromUrl;
        }
      }

      const syncLabel = () => {
        const selected = nativeSelect.options[nativeSelect.selectedIndex];

        valueEl.textContent = selected ? selected.textContent.trim() : '';

        options.forEach((btn) => {
          btn.setAttribute(
            'aria-selected',
            btn.dataset.value === nativeSelect.value ? 'true' : 'false'
          );
        });
      };

      /* 28.09.2026: поки список відкритий, товари клікаються як завжди: клік
         по товару закриває список і відкриває товар. Раніше сітка під
         відкритим списком не приймала кліків, і перший клік лише закривав
         список. */
      const close = () => {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };

      const open = () => {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.focus();
      };

      const handleSelect = (e, btn) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        nativeSelect.value = btn.dataset.value;
        syncLabel();
        close();

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', nativeSelect.value);
        nextUrl.searchParams.delete('page');

        window.location.assign(nextUrl.toString());
      };

      syncLabel();

      /* 28.09.2026: кнопка й варіанти працюють на click, а не на pointerdown.
         На телефоні список відкривався вже на дотику пальця і лягав на кнопку,
         тож click того самого тапу потрапляв у перший варіант; а вибраний
         варіант ховав список, і click падав на картку товару під ним. */
      trigger.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          dropdown.classList.contains('is-open') ? close() : open();
        },
        true
      );

      options.forEach((btn) => {
        btn.addEventListener(
          'click',
          (e) => handleSelect(e, btn),
          true
        );
      });

      document.addEventListener('pointerdown', (e) => {
        if (dropdown.isConnected && !dropdown.contains(e.target)) close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && dropdown.isConnected) close();
      });
    });
  };

  const initAdaptisAtc = () => {
    if (window._adaptisAtcInit) return;
    window._adaptisAtcInit = true;

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-adaptis-atc-form]');
      if (!form) return;

      e.preventDefault();

      const btn = form.querySelector('[data-adaptis-atc-button]');
      if (!btn) return;

      const defaultText = btn.dataset.textDefault || '+ До кошика';
      const loadingText = btn.dataset.textLoading || 'Додаємо...';
      const addedText = btn.dataset.textAdded || 'Додано в кошик';
      const errorText = 'Помилка';

      btn.textContent = loadingText;
      btn.disabled = true;

      try {
        const variantId = form.querySelector('[name="id"]')?.value;
        const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantity
          })
        });

        const data = await res.json();

        if (!res.ok) {
          console.error('Adaptis ATC error:', data);
          btn.textContent = errorText;

          setTimeout(() => {
            btn.textContent = defaultText;
            btn.disabled = false;
          }, 2000);

          return;
        }

        btn.textContent = addedText;

        await new Promise((resolve) => setTimeout(resolve, 300));

        const cartRes = await fetch(`/cart.js?t=${Date.now()}`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        const cart = await cartRes.json();

        document
          .querySelectorAll(
            '[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"]'
          )
          .forEach((el) => {
            el.textContent = cart.item_count;
          });

        const cartBubble = document.querySelector('.cart-bubble');
        if (cartBubble) {
          cartBubble.removeAttribute('hidden');
          cartBubble.classList.remove('visually-hidden');
          cartBubble.style.display = '';
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { cart }
          })
        );

        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart }
          })
        );

        const cartToggle =
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[aria-controls*="cart" i]') ||
          document.querySelector('[aria-haspopup="dialog"][data-cart]') ||
          document.querySelector('[aria-haspopup="dialog"][aria-controls*="cart" i]');

        if (cartToggle) {
          cartToggle.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            })
          );
        }

        setTimeout(() => {
          btn.textContent = defaultText;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('Adaptis ATC request failed:', err);

        btn.textContent = errorText;

        setTimeout(() => {
          btn.textContent = defaultText;
          btn.disabled = false;
        }, 2000);
      }
    });
  };

  const initAdaptisMobileFiltersButton = () => {
    document.querySelectorAll('[data-mobile-filters-open]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (!isMobile) return;

        const drawerTrigger =
          document.querySelector('button[aria-controls="filters-drawer"]') ||
          document.querySelector('[aria-controls="filters-drawer"]');

        if (drawerTrigger) {
          drawerTrigger.click();
          return;
        }

        const drawer = document.getElementById('filters-drawer');
        const dialog = drawer?.querySelector('dialog');

        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
          document.documentElement.classList.add('overflow-hidden');
          document.body.classList.add('overflow-hidden');
        }
      });
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      scrollToHashCard();
      initAdaptisSort();
      initAdaptisAtc();
      initAdaptisMobileFiltersButton();
      /* 25.09.2026: тема перемальовує секцію при зміні фільтра: підключаємо
         сортування до нових елементів. */
      const sec = document.querySelector('.adaptis-collection-section');
      if (sec && window.MutationObserver) {
        let t = null;
        new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => { initAdaptisSort(); initAdaptisMobileFiltersButton(); }, 50); })
          .observe(sec, { childList: true, subtree: true });
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
